var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.navItems), function(item, index) {
    return _c('li', {
      staticClass: "nav-item"
    }, [(item.title) ? [_c('SidebarNavTitle', {
      attrs: {
        "name": item.name,
        "classes": item.class,
        "wrapper": item.wrapper
      }
    })] : (item.divider) ? [_c('li', {
      staticClass: "divider"
    })] : [(item.children) ? [_c('SidebarNavDropdown', {
      attrs: {
        "name": item.name,
        "url": item.url,
        "icon": item.icon
      }
    }, [_vm._l((item.children), function(child, index) {
      return [(child.children) ? [_c('SidebarNavDropdown', {
        attrs: {
          "name": child.name,
          "url": child.url,
          "icon": child.icon
        }
      }, _vm._l((item.children), function(child, index) {
        return _c('li', {
          staticClass: "nav-item"
        }, [_c('SidebarNavLink', {
          attrs: {
            "name": child.name,
            "url": child.url,
            "icon": child.icon,
            "badge": child.badge
          }
        })], 1)
      }))] : [_c('li', {
        staticClass: "nav-item"
      }, [_c('SidebarNavLink', {
        attrs: {
          "name": child.name,
          "url": child.url,
          "icon": child.icon,
          "badge": child.badge
        }
      })], 1)]]
    })], 2)] : [_c('SidebarNavLink', {
      attrs: {
        "name": item.name,
        "url": item.url,
        "icon": item.icon,
        "badge": item.badge
      }
    })]]], 2)
  })), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75373e29","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = vVMf
// module chunks = 1